// libs
import React from 'react';

import * as ContentDetails from '@/components/ContentDetails';
// hooks
import { useHeroContext } from '@/modules/corporate/components/DetailPageComponents/DetailHero/context';

import { HeroComposition } from '../../types';

const DueDate: HeroComposition['DueDate'] = ({ className }) => {
  const { content } = useHeroContext();

  if (!content.dueDate) {
    return null;
  }

  return (
    <ContentDetails.Provider content={content}>
      <ContentDetails.DueDate className={className} />
    </ContentDetails.Provider>
  );
};

export default DueDate;
